.wrapper {
  display: flex;
  padding: 0 var(--ant-size-xl);
  background-color: white;
  align-items: center;
  margin-bottom: var(--space-4);

  .menuWrapper {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: var(--ant-size-sm);
  }
}
